import { parseISO } from 'date-fns';
import type { EventDialInInformation, EventParticipantRole } from 'models';
import type {
  NodeCommonTodoDataObject,
  NodeTodoDataObject,
  TelehealthRequestTodoDataObject,
  TelehealthVisitEventDataObject,
} from './service';

export type NodeTodo = TelehealthRequestTodo;

export type TelehealthRequestTodo = {
  // TODO: rename telehealthVisit because it can be also video conference, reminder, webinar
  event: TelehealthVisitEvent;
  type: TelehealthRequestTodoType;
} & CommonNodeTodo;

export type TelehealthVisitEvent = {
  author?: string;
  dialInInformation?: EventDialInInformation;
  endTime: Date;
  id: string;
  name: string;
  role: EventParticipantRole;
  startTime: Date;
  type: 'telehealth_visit';
};

type CommonNodeTodo = {
  endTime: Date;
  id: string;
  path: string;
  priority: number;
  startTime: Date;
  status: 'active';
};

type TelehealthRequestTodoType = 'event_enter' | 'event_rsvp';

export const createNodeTodo = (todo: NodeTodoDataObject): NodeTodo => createTelehealthRequestTodo(todo);

const createCommonNodeTodo = (todo: NodeCommonTodoDataObject): CommonNodeTodo => ({
  endTime: parseISO(todo.endTime),
  id: todo._id,
  path: todo.path,
  priority: todo.priority,
  startTime: parseISO(todo.startTime),
  status: todo.status,
});

export const createTelehealthRequestTodo = (todo: TelehealthRequestTodoDataObject): TelehealthRequestTodo => ({
  ...createCommonNodeTodo(todo),
  event: createTelehealthVisitEvent(todo.event, todo.eventData),
  type: todo.type,
});

const createTelehealthVisitEvent = (
  event: string,
  eventData: TelehealthVisitEventDataObject,
): TelehealthVisitEvent => ({
  author: eventData.author,
  dialInInformation: eventData.dialInInformation,
  endTime: parseISO(eventData.endTime),
  id: event,
  name: eventData.name,
  role: eventData.participant.role,
  startTime: parseISO(eventData.startTime),
  type: eventData.type,
});
